import type { Dict } from '../utils'

export const colors = {
  activeBg: 'skyBlue.main',
  border: 'sandstone.main',
  color: 'sandstone.10',
  hover: 'skyBlue.hover',
  main: 'seaBlue.main',
}

export const iconSizeMapper: Dict = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'lg',
  xxl: 'xl',
}
